import type { ReactNode } from 'react';
import { Flex, Typography } from 'antd';

interface PageHeaderProps {
  title: string;
  description?: string;
  extra?: ReactNode;
}

export const PageHeader = ({ title, description, extra }: PageHeaderProps): React.ReactElement => (
  <Flex justify="space-between" align="flex-start" gap={16} wrap="wrap" className="page-header">
    <div>
      <Typography.Title level={2} className="page-header__title">
        {title}
      </Typography.Title>
      {description ? (
        <Typography.Paragraph type="secondary" className="page-header__description">
          {description}
        </Typography.Paragraph>
      ) : null}
    </div>
    {extra ? <Flex gap={8} wrap>{extra}</Flex> : null}
  </Flex>
);
